import React, { FC } from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import DateRangeInput from 'src/components/DateRangeInput';
import { DomainSelect } from 'src/components/ApiField';

interface Props {
  startDateFilter?: string;
  endDateFilter?: string;
  domainFilter?: string;
  showCustomerSatisfaction?: boolean;
  onShowCustomerSatisfaction: (event) => void;
  onDateFilterChange: (startDate?: string, endDate?: string) => void;
  onDomainFilterChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const FilterInputs: FC<Props> = ({
  showCustomerSatisfaction,
  onShowCustomerSatisfaction,
  domainFilter,
  onDomainFilterChange,
  endDateFilter,
  startDateFilter,
  onDateFilterChange,
}) => {
  return (
    <Grid container spacing={2} justifyContent='flex-end'>
      <Grid item>
        <DateRangeInput startDate={startDateFilter} endDate={endDateFilter} onChange={onDateFilterChange} />
      </Grid>
      <Grid item>
        <DomainSelect size='small' onChange={onDomainFilterChange} value={domainFilter} />
      </Grid>
      <Grid item>
        <FormControlLabel
          style={{ marginBottom: 0 }}
          control={<Checkbox checked={showCustomerSatisfaction} onChange={onShowCustomerSatisfaction} />}
          label='Filtrer par avis clients'
        />
      </Grid>
    </Grid>
  );
};

export default FilterInputs;
